<script lang="ts">
	import ApplicationForm from './ApplicationForm.svelte';
	import Success from './Success.svelte';
	import type { ApplicationFormData } from './types';

	export let action: string;
	export let uploadAction: string;
	export let ajaxSubmitURL: string;
	export let jobId: string;
	export let jobTitle: string;
	enum Panel {
		form,
		success
	}
	let panel: Panel = Panel.form;
	let formData: ApplicationFormData = null;
	const onSuccess = (event: CustomEvent) => {
		formData = event.detail;
		panel = Panel.success;
	};
</script>

{#if panel === Panel.form}
	<ApplicationForm {action} {ajaxSubmitURL} {uploadAction} {jobTitle} {jobId} on:success={onSuccess} />
{:else}
	<Success {formData} {jobTitle} />
{/if}
